import React from 'react';

import Select from 'react-select';

import nominationApprovalStatus from '@/data/nominationApprovalStatus';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectNominationApprovalStatus: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={nominationApprovalStatus.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={nominationApprovalStatus}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectNominationApprovalStatus;
